import React, { useEffect } from 'react';
import Btn from '../atoms/btn';

const closePopup = (onClose) => {
  document.body.classList.remove('lock-scroll');
  onClose();
};

const onClickContent = (ev, onClose) => {
  const classList = ev.target.classList.value;
  const isCloseContainer = classList.includes('close-js');
  if (isCloseContainer) {
    closePopup(onClose);
  }
};

const DsModal = ({ children, onClose, fullScreen }) => {
  useEffect(() => {
    document.body.classList.add('lock-scroll');
    return () => {
      document.body.classList.remove('lock-scroll');
    };
  }, [children]);
  return (
          <div className="fixed inset-0 z-front max-h-screen overflow-y-auto">
            <div className="fixed inset-0 bg-gray-900 opacity-50 cursor-pointer"
                 onClick={() => closePopup(onClose)}/>
            <div className="relative mx-auto z-10 m-4 md:m-8  flex justify-center close-js"
                 onClick={(ev) => onClickContent(ev, onClose)}>
              <div className={`relative bg-white mx-auto inline-flex ${fullScreen ? 'w-full h-modal' : ''}`}>
                <Btn icon="cross"
                     onClick={() => closePopup(onClose)}
                     // eslint-disable-next-line max-len
                     className="absolute top-0 right-0 z-front text-white bg-gray-700 p-1 rounded-full md:-mt-2 md:-mr-2"/>
                {children}
              </div>
            </div>

          </div>
  );
};

export default DsModal;
